// import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

import { PageDirectoryEntryName } from "../../api/PageDirectory";
import APChip from "../../components/APChip";
import { formatDate } from "../../helpers/dates";
import { useAuth } from "../../providers/AuthProvider";
import {
  DossierStatus,
  DossierStatusColorMap,
  DossierStatusLabelMap,
} from "../../types/Dossier";

const DossierCard = ({
  id,
  status,
  identity,
  startDate,
  endDate,
  vehicleMake,
  vehicleModel,
  vehicleYear,
  vehicleImage,
  driverPortalEnabled,
}: {
  id: string;
  status: DossierStatus;
  identity: string;
  startDate: string;
  endDate: string;
  vehicleMake: string;
  vehicleModel: string;
  vehicleYear: string;
  vehicleImage: string;
  driverPortalEnabled?: boolean;
}) => {
  // const color = statusToColor[status];
  const { getScopedPageUrl, inAppScope } = useAuth();
  const destination: PageDirectoryEntryName =
    status === "New" || (inAppScope("external") && !driverPortalEnabled)
      ? "viewDossier"
      : "dossierActivated";

  return (
    <Card sx={{ display: "flex" }} variant="outlined">
      <CardActionArea
        color="primary"
        sx={{
          display: "flex",
          backgroundColor: "surface.main",
        }}
        component={Link}
        to={getScopedPageUrl(destination, id)}
      >
        <Box
          sx={{
            display: "flex",
            p: 2,
            flexGrow: 1,
            flex: 2,
            alignItems: "center",
          }}
        >
          <Box sx={{ flexGrow: 1 }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box
                mb={1}
                sx={{ display: "flex", flexDirection: "row", gap: 1 }}
              >
                <APChip
                  text={DossierStatusLabelMap[status]}
                  color={DossierStatusColorMap[status]}
                />
              </Box>
              <Box pl={0.5}>
                <Typography variant="titleMedium" color="onSurface.main">
                  {vehicleYear} {vehicleMake} {vehicleModel}
                </Typography>
                <Typography variant="bodyMedium" color="onSurface.main">
                  {identity}
                </Typography>
                <Typography variant="bodyMedium" color="onSurface.main">
                  {startDate &&
                    endDate &&
                    `${formatDate(startDate)} - ${formatDate(endDate)}`}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <CardMedia
          component="img"
          sx={{
            minWidth: "5rem",
            maxHeight: "8rem",
            flex: 3,
            maxWidth: "10rem",
          }}
          image={vehicleImage}
          alt={`${vehicleYear} ${vehicleMake} ${vehicleModel}`}
        />
      </CardActionArea>
    </Card>
  );
};

export default DossierCard;
